import { defaultMapOptions } from '../constants';
import MapsApiBaseService from './MapsApiBaseService';

export default class MapService extends MapsApiBaseService {
  #mapListeners = {};
  #map = null;

  async initMap(element, mapOptions) {
    await this.init();
    this.#map = this.#createMap(element, mapOptions);
  }

  get map() {
    return this.#map;
  }

  addMapListener(event, callback) {
    this.#mapListeners[event] = this.#map.addListener(event, callback);
  }

  removeAllListeners() {
    Object.values(this.#mapListeners).forEach((listener) => {
      this.googleMaps.event.removeListener(listener);
    });
  }

  getBounds() {
    return this.#map?.getBounds();
  }

  getBoundsDistance() {
    const bounds = this.getBounds();
    const northEast = bounds.getNorthEast();
    const southWest = bounds.getSouthWest();

    return this.googleMaps?.geometry.spherical.computeDistanceBetween(
      northEast,
      southWest,
    );
  }

  getCenter() {
    const center = this.#map?.getCenter();

    return {
      lat: center?.lat(),
      lng: center?.lng(),
    };
  }

  setCenter(coords) {
    this.#map?.setCenter(coords);
  }

  setBounds(coords) {
    const bounds = new this.googleMaps.LatLngBounds();

    bounds.extend({ lng: coords.maxLon, lat: coords.maxLat });
    bounds.extend({ lng: coords.minLon, lat: coords.minLat });
    bounds.extend({ lng: coords.maxLon, lat: coords.minLat });
    bounds.extend({ lng: coords.minLon, lat: coords.maxLat });

    this.#map.fitBounds(bounds, 0);
  }

  getZoom() {
    return this.#map?.getZoom();
  }

  setZoom(zoom) {
    this.#map?.setZoom(zoom);
  }

  #createMap(element, mapOptions) {
    return new this.googleMaps.Map(element, {
      ...defaultMapOptions,
      ...mapOptions,
    });
  }
}
